// import '../../js/customizer.js';
/* global google */
/* global Splide */
/* global eventMapData */

function createCanvasAnimator(canvas, navContainer) {
  // CANVAS CONFIGURATION
  const ctx = canvas.getContext('2d');

  // Set fixed size for the hamburger canvas element
  const dpr = window.devicePixelRatio || 1;
  const SIZE = 45;
  canvas.width = SIZE * dpr;
  canvas.height = SIZE * dpr;
  canvas.style.width = `${SIZE}px`;
  canvas.style.height = `${SIZE}px`;
  ctx.scale(dpr, dpr);

  // Canvas Drawing Parameters
  const centerX = SIZE / 2;
  const centerY = SIZE / 2;
  const lineWidth = 4;
  const radius = SIZE / 2 - lineWidth / 2; // Adjusts radius to fit area
  const fullCircle = 2 * Math.PI;
  const animationSpeed = 0.12; // Quick speed for a UI interaction
  const startAngle = -0.5 * Math.PI; // Starts at 12 o'clock

  // STATE
  let currentEndAngle = 0; // Tracks the size of the arc (0 to fullCircle)
  let animationFrameId = null;

  // CANVAS DRAWING FUNCTIONS

  function drawArc() {
    ctx.clearRect(0, 0, SIZE, SIZE);

    // Draw the transparent track (Background)
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius, 0, fullCircle);
    ctx.strokeStyle = 'transparent';
    ctx.lineWidth = lineWidth;
    ctx.stroke();

    // Draw the animated arc segment
    if (currentEndAngle > 0) {
      ctx.beginPath();
      ctx.arc(
        centerX,
        centerY,
        radius,
        startAngle,
        currentEndAngle + startAngle
      );
      ctx.strokeStyle = '#ff2ec4'; // Indigo color
      ctx.lineWidth = lineWidth;

      // Only set lineCap='round' if the arc isn't a full circle
      ctx.lineCap = currentEndAngle < fullCircle ? 'round' : 'butt';

      ctx.stroke();
    }
  }

  // Animation loop. Runs until arc is drawn or erased completely
  // @param {boolean} isMenuOpening To determine which direction the animation should go, true for opening, false for closing
  function animateCircle(isMenuOpening) {
    const step = isMenuOpening ? animationSpeed : -animationSpeed;
    currentEndAngle += step;
    // console.log(isMenuOpening, 'isMenuOpening');
    // console.log(currentEndAngle, 'currentEndAngle');
    // console.log(fullCircle, 'fullCircle');
    // console.log(step, 'step');
    // console.log(animationFrameId, 'animationFrameId');

    // Boundary Checks and Stopping

    // Drawing complete (Menu is now OPEN)
    if (currentEndAngle >= fullCircle) {
      currentEndAngle = fullCircle;
      stopAnimation();
      navContainer.classList.add('toggled');
      drawArc(); // Ensure final state is drawn with lineCap='butt'
      return;
    }

    // Erasing complete (Menu is now CLOSED)
    if (currentEndAngle <= 0) {
      currentEndAngle = 0;
      stopAnimation();
      setTimeout(() => {
        const wasMenuReopened = navContainer.classList.contains('toggled');
        if (!wasMenuReopened) {
          navContainer.classList.add('closed');
        }
      }, 350);
      navContainer.classList.remove('closing', 'toggled');
      drawArc(); // Ensure final state is truly clear (0 length)
      return;
    }

    // Continue Loop
    drawArc();
    animationFrameId = requestAnimationFrame(() =>
      animateCircle(isMenuOpening)
    );
  }

  function stopAnimation() {
    if (animationFrameId) {
      cancelAnimationFrame(animationFrameId);
      animationFrameId = null;
    }
  }

  // Called on page load to draw the initial state of the canvas
  drawArc();

  // Return the necessary control functions
  return {
    start: animateCircle,
    stop: stopAnimation,
    drawInitial: drawArc,
  };
}

document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('.menu-toggle');
  const navContainer = document.getElementById('site-navigation');
  const canvas = document.getElementById('hamburger__canvas');

  // Fail gracefully if essential elements are missing
  if (!menuToggle || !navContainer || !canvas) {
    console.warn(
      'Missing required menu elements (button, nav, or canvas). Animation skipped.'
    );
    // Fallback: If canvas is missing, just use basic CSS class toggling
    if (menuToggle && navContainer) {
      menuToggle.addEventListener('click', () => {
        const isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
        menuToggle.setAttribute('aria-expanded', !isExpanded);
        navContainer.classList.toggle('toggled', !isExpanded);
        menuToggle.classList.toggle('is-active', !isExpanded);
      });
    }
    return;
  }

  // MAIN EXECUTION SCOPE
  let isMenuOpen = false; // Tracks the menu state

  // Instantiate the canvas animator controller and getting in return the control functions
  const animator = createCanvasAnimator(canvas, navContainer);

  // Main toggle function
  function toggleMenu() {
    // 1. Stop any currently running animation
    animator.stop();

    // 2. Flip the state
    isMenuOpen = !isMenuOpen;

    // 3. Update DOM
    menuToggle.setAttribute('aria-expanded', isMenuOpen);
    menuToggle.classList.toggle('is-active', isMenuOpen);

    // 4. Set the initial visibility
    navContainer.classList.add('toggled');
    if (isMenuOpen) {
      navContainer.classList.remove('closed');
    } else {
      // navContainer.classList.remove('toggled');
      navContainer.classList.add('closing');
    }

    // 5. Start the Canvas Animation
    animator.start(isMenuOpen);
  }

  // EVENT LISTENER
  menuToggle.addEventListener('click', toggleMenu);
});

document.addEventListener('keyup', (e) => {
  if (e.key === 'Tab') {
    console.log('Focused Element:', document.activeElement);
  }
});

/**
 * Reusable scroll parallax.
 * Add the `js-parallax` class to any element whose parent clips overflow
 * and which is itself sized larger than that parent (see .hero-block__background
 * in _modules.scss for the pattern). Speed and direction are tuned per element
 * via `data-parallax-speed` (defaults to 0.3).
 */
function initParallax() {
  // Explicit opt-ins (e.g. the hero) plus Cover blocks flagged via the
  // "Parallax Background" sidebar toggle. Both feed the same engine.
  const items = [
    ...document.querySelectorAll('.js-parallax'),
    ...document.querySelectorAll(
      '.wp-block-cover.has-av-parallax:not(.has-parallax) .wp-block-cover__image-background, .wp-block-cover.has-av-parallax:not(.has-parallax) .wp-block-cover__video-background'
    ),
  ];

  if (!items.length) return;

  // Respect user motion preferences instead of forcing the effect on everyone
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;
  if (prefersReducedMotion) return;

  const layers = Array.from(items).map((el) => ({
    el,
    container: el.parentElement,
    speed: parseFloat(el.getAttribute('data-parallax-speed')) || 0.3,
    active: false,
  }));

  // Only recalculate layers currently on screen to avoid wasted scroll work
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const layer = layers.find((item) => item.el === entry.target);
        if (layer) layer.active = entry.isIntersecting;
      });
    },
    { rootMargin: '20% 0px' }
  );
  layers.forEach((layer) => observer.observe(layer.el));

  let ticking = false;

  function updateParallax() {
    ticking = false;

    layers.forEach(({ el, container, speed, active }) => {
      if (!active) return;

      const rect = container.getBoundingClientRect();
      const distanceFromCenter =
        rect.top + rect.height / 2 - window.innerHeight / 2;

      // Clamp travel to the buffer built into the element's oversized CSS
      // (e.g. height: 130% / top: -15%) so the effect never reveals a gap
      const maxOffset = rect.height * 0.15;
      const offset = Math.max(
        -maxOffset,
        Math.min(maxOffset, distanceFromCenter * speed * -1)
      );

      el.style.transform = `translate3d(0, ${offset}px, 0)`;
    });
  }

  function requestParallaxTick() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(updateParallax);
  }

  window.addEventListener('scroll', requestParallaxTick, { passive: true });
  window.addEventListener('resize', requestParallaxTick);

  updateParallax();
}

document.addEventListener('DOMContentLoaded', initParallax);

/**
 * Stagger the resting gradient-flow animation on primary buttons by screen
 * location so the effect ripples from button to button (left -> right, matching
 * each button's own gradient flow) instead of every button sweeping in unison.
 * Each button gets a negative animation-delay (so it starts already mid-cycle,
 * no initial pause); leftmost buttons are furthest ahead in the cycle, so the
 * sweep visibly travels rightward across the page.
 */
function initButtonFlowStagger() {
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;
  if (prefersReducedMotion) return;

  // Broad candidate set; the computed-style check below ensures we only touch
  // buttons actually running the btn-gradient-flow animation (the primaries).
  const candidates = document.querySelectorAll(
    '.btn, .wp-block-button, .wp-block-button__link, .add_to_cart_button, ' +
      '.button.wc-forward, .woocommerce button, .woocommerce-button, ' +
      '.wc-block-cart__submit-button, .wc-block-components-checkout-place-order-button'
  );
  if (!candidates.length) return;

  // Seconds of phase shift per pixel of horizontal position. Larger = a tighter
  // ripple. x is dominant so the wave reads left -> right; a small y weight
  // keeps vertically-stacked buttons from sweeping in perfect unison.
  const SPREAD = 0.003;
  const Y_WEIGHT = 0.3;

  // A button counts as "pinned" if it (or any ancestor) is sticky/fixed, e.g.
  // the CTA inside the sticky .site-header. Pinned buttons stay on screen while
  // the page scrolls, so their place in the wave shifts and must be recomputed.
  function isPinned(el) {
    let node = el;
    while (node && node !== document.body) {
      const pos = getComputedStyle(node).position;
      if (pos === 'fixed' || pos === 'sticky') return true;
      node = node.parentElement;
    }
    return false;
  }

  function setDelay(el, duration) {
    const rect = el.getBoundingClientRect();
    if (!rect.width && !rect.height) return; // skip hidden buttons

    const x = rect.left + window.scrollX;
    const y = rect.top + window.scrollY;

    // Phase increases with position so leftmost buttons lead. Subtracting the
    // duration keeps the delay negative (no initial pause) while preserving the
    // left -> right ordering.
    const phase = ((x + y * Y_WEIGHT) * SPREAD) % duration;
    el.style.animationDelay = `${(phase - duration).toFixed(2)}s`;
  }

  // Buttons running the flow animation, split into all vs. pinned sets.
  let flowButtons = [];
  let pinnedButtons = [];

  function collect() {
    flowButtons = [];
    pinnedButtons = [];
    candidates.forEach((el) => {
      const styles = getComputedStyle(el);
      const runsFlow = styles.animationName
        .split(',')
        .some((name) => name.trim() === 'btn-gradient-flow');
      if (!runsFlow) return;

      // Stay in sync with whatever duration the SCSS defines.
      const entry = {
        el,
        duration: parseFloat(styles.animationDuration) || 12,
      };
      flowButtons.push(entry);
      if (isPinned(el)) pinnedButtons.push(entry);
    });
  }

  function applyAll() {
    flowButtons.forEach(({ el, duration }) => setDelay(el, duration));
  }

  collect();
  applyAll();

  // Pinned buttons follow the viewport, so recompute their place in the wave as
  // the page scrolls. Throttled to one update per animation frame.
  let ticking = false;
  window.addEventListener(
    'scroll',
    () => {
      if (ticking || !pinnedButtons.length) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        pinnedButtons.forEach(({ el, duration }) => setDelay(el, duration));
      });
    },
    { passive: true }
  );

  // Layout (and therefore positions) changes on resize, so recompute.
  let resizeTimer = null;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      collect();
      applyAll();
    }, 200);
  });
}

document.addEventListener('DOMContentLoaded', initButtonFlowStagger);

class CSSMarker extends google.maps.OverlayView {
  constructor(position, title, type, url, id) {
    super();
    this.position = position;
    this.title = title;
    this.type = type;
    this.url = url;
    this.id = id;
    this.div = null;
    this.visible = true;
  }

  onAdd() {
    this.div = document.createElement('button');
    this.div.className = 'map-pin';
    if (this.type) this.div.classList.add('map-pin--' + this.type);

    this.div.innerHTML = `<span class="sr-only">${this.title}</span>`; // Accessibility

    // Interaction: Click pin to go to event or scroll to card
    this.div.addEventListener('click', () => {
      // Option A: Go straight to link
      // window.location.href = this.url;

      // Option B: Highlight card (if you prefer single-page feel)
      highlightEventCard(this.id);
    });

    const panes = this.getPanes();
    panes.overlayMouseTarget.appendChild(this.div);
  }

  draw() {
    const overlayProjection = this.getProjection();
    const pos = overlayProjection.fromLatLngToDivPixel(this.position);

    if (this.div) {
      const markerWidth = 24;
      const markerHeight = 24;

      this.div.style.left = pos.x - markerWidth / 2 + 'px';
      this.div.style.top = pos.y - markerHeight + 'px';
      this.div.style.position = 'absolute';
      this.div.style.display = this.visible ? 'block' : 'none';
    }
  }

  onRemove() {
    if (this.div) {
      this.div.parentNode.removeChild(this.div);
      this.div = null;
    }
  }

  // Helper to toggle visibility for filtering
  setVisible(visible) {
    this.visible = visible;

    if (this.div) {
      this.div.style.display = visible ? 'block' : 'none';
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  // 1. CHECK IF MAP EXISTS
  const mapElement = document.getElementById('google-map-render');

  if (
    !mapElement ||
    typeof google === 'undefined' ||
    typeof eventMapData === 'undefined'
  ) {
    return;
  }

  // 2. INIT MAP
  const map = new google.maps.Map(mapElement, {
    zoom: 4,
    center: { lat: 39.8283, lng: -98.5795 },

    // REMOVES BUTTONS
    disableDefaultUI: true,

    // DARK MODE STYLES
    styles: [
      {
        elementType: 'geometry',
        stylers: [{ color: '#212121' }],
      },
      {
        elementType: 'labels.icon',
        stylers: [{ visibility: 'off' }],
      },
      {
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }],
      },
      {
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#212121' }],
      },
      {
        featureType: 'administrative',
        elementType: 'geometry',
        stylers: [{ color: '#757575' }],
      },
      {
        featureType: 'administrative.country',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }],
      },
      {
        featureType: 'administrative.land_parcel',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'administrative.locality',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#bdbdbd' }],
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#181818' }],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#616161' }],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#1b1b1b' }],
      },
      {
        featureType: 'road',
        elementType: 'geometry.fill',
        stylers: [{ color: '#2c2c2c' }],
      },
      {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#8a8a8a' }],
      },
      {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [{ color: '#373737' }],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ color: '#3c3c3c' }],
      },
      {
        featureType: 'road.highway.controlled_access',
        elementType: 'geometry',
        stylers: [{ color: '#4e4e4e' }],
      },
      {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#616161' }],
      },
      {
        featureType: 'transit',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#000000' }],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#3d3d3d' }],
      },
    ],
  });

  const bounds = new google.maps.LatLngBounds();
  const markers = []; // Store markers to filter them later

  // 3. PLACE MARKERS FROM PHP DATA
  eventMapData.forEach((event) => {
    if (event.lat && event.lng) {
      console.log(event);
      const position = new google.maps.LatLng(event.lat, event.lng);
      const marker = new CSSMarker(
        position,
        event.title,
        event.type,
        event.url,
        event.id
      );

      marker.setMap(map);
      markers.push(marker);

      // It expands the invisible "box" to include this new pin
      bounds.extend(position);
    }
  });

  console.log(markers);
  if (markers.length > 0) {
    map.fitBounds(bounds);
  }

  // ==========================================
  // 4. FILTERING LOGIC
  // ==========================================

  // Elements
  const searchInput = document.getElementById('eventsQuery');
  const typeInputs = document.querySelectorAll('input[name="eventType"]');
  const dateSelect = document.getElementById('eventsDatePreset');
  const customDateRow = document.getElementById('dateRangeRow');
  const startInput = document.getElementById('eventsStart');
  const endInput = document.getElementById('eventsEnd');
  const clearBtn = document.getElementById('eventsClear');
  const gridItems = document.querySelectorAll('.event-card');
  const countSpan = document.getElementById('eventsCount');

  // Master Filter Function
  function runFilters() {
    const query = searchInput.value.toLowerCase();

    // Get checked types
    const checkedTypes = Array.from(typeInputs)
      .filter((input) => input.checked)
      .map((input) => input.value);

    // Date Logic
    const dateMode = dateSelect.value;
    const startDate = startInput.value ? new Date(startInput.value) : null;
    const endDate = endInput.value ? new Date(endInput.value) : null;
    const now = new Date();

    let visibleCount = 0;

    // Loop through all DOM Cards
    gridItems.forEach((card) => {
      let isVisible = true;

      // A. Search Text (Title or Subtitle)
      const title = card.querySelector('.event-title').innerText.toLowerCase();
      const loc = card.querySelector('.event-sub').innerText.toLowerCase();
      if (query && !title.includes(query) && !loc.includes(query)) {
        isVisible = false;
      }

      // B. Event Type
      const type = card.getAttribute('data-type');
      if (
        isVisible &&
        checkedTypes.length > 0 &&
        !checkedTypes.includes(type)
      ) {
        isVisible = false;
      }

      // C. Date Filter
      const eventDateStr = card.getAttribute('data-date'); // Y-m-d from PHP
      if (isVisible && eventDateStr) {
        const eventDate = new Date(eventDateStr);

        if (dateMode === 'month') {
          // Check if same Month and Year
          if (
            eventDate.getMonth() !== now.getMonth() ||
            eventDate.getFullYear() !== now.getFullYear()
          ) {
            isVisible = false;
          }
        } else if (dateMode === 'range' && startDate) {
          // Check Range
          if (eventDate < startDate) isVisible = false;
          if (endDate && eventDate > endDate) isVisible = false;
        }
      }

      // APPLY VISIBILITY
      // 1. Hide/Show Card
      card.style.display = isVisible ? 'block' : 'none';
      if (isVisible) visibleCount++;

      // 2. Hide/Show Map Pin (Syncing!)
      // We find the marker that matches this card's title or ID
      const marker = markers.find(
        (m) => m.title === card.querySelector('.event-title').innerText
      );
      if (marker) {
        marker.setVisible(isVisible);
      }
    });

    // Update Count Text
    if (countSpan) countSpan.innerText = `${visibleCount} events`;
  }

  // Event Listeners
  searchInput.addEventListener('input', runFilters);
  typeInputs.forEach((input) => input.addEventListener('change', runFilters));

  dateSelect.addEventListener('change', function () {
    // Toggle custom range inputs
    if (this.value === 'range') {
      customDateRow.style.display = 'grid';
    } else {
      customDateRow.style.display = 'none';
    }
    runFilters();
  });

  startInput.addEventListener('change', runFilters);
  endInput.addEventListener('change', runFilters);

  clearBtn.addEventListener('click', () => {
    searchInput.value = '';
    typeInputs.forEach((input) => (input.checked = false));
    dateSelect.value = 'upcoming';
    customDateRow.style.display = 'none';
    runFilters();
  });
});

/**
 * // Initialize all custom selects on the page
 * // Looks for .custom-select wrappers and syncs them with their internal native <select>
 */
function initAllCustomSelects() {
  const customSelects = document.querySelectorAll('.custom-select');

  customSelects.forEach((wrapper) => {
    const nativeSelect = wrapper.querySelector('select');
    const trigger = wrapper.querySelector('.custom-select__trigger');
    const options = Array.from(
      wrapper.querySelectorAll('.custom-select__option')
    );
    const triggerText = trigger ? trigger.querySelector('span') : null;

    if (!nativeSelect || !trigger || !options.length) return;

    let currentFocusIndex = -1;

    const toggleDropdown = (state) => {
      const isOpen =
        state !== undefined ? state : !wrapper.classList.contains('is-open');
      wrapper.classList.toggle('is-open', isOpen);
      trigger.setAttribute('aria-expanded', isOpen);
      if (!isOpen) currentFocusIndex = -1;
    };

    const selectOption = (index) => {
      if (index < 0 || index >= options.length) return;

      const option = options[index];
      const val = option.getAttribute('data-value');

      triggerText.innerText = option.innerText;
      options.forEach((opt) => opt.classList.remove('is-selected'));
      option.classList.add('is-selected');

      nativeSelect.value = val;
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      toggleDropdown(false);
      trigger.focus(); // Return focus to trigger after selection
    };

    // Keyboard Navigation Logic
    wrapper.addEventListener('keydown', (e) => {
      const isOpen = wrapper.classList.contains('is-open');

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (!isOpen) toggleDropdown(true);
        currentFocusIndex = (currentFocusIndex + 1) % options.length;
        options[currentFocusIndex].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        currentFocusIndex =
          (currentFocusIndex - 1 + options.length) % options.length;
        options[currentFocusIndex].focus();
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (!isOpen) {
          toggleDropdown(true);
        } else if (currentFocusIndex >= 0) {
          selectOption(currentFocusIndex);
        }
      } else if (e.key === 'Escape') {
        toggleDropdown(false);
        trigger.focus();
      }
    });

    // Click events
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      toggleDropdown();
    });

    options.forEach((option, index) => {
      // Ensure options are focusable via JS but not necessarily in the Tab flow
      // unless the menu is open (standard ARIA pattern)
      option.setAttribute('tabindex', '-1');

      option.addEventListener('click', (e) => {
        e.stopPropagation();
        selectOption(index);
      });
    });
  });
}
document.addEventListener('DOMContentLoaded', () => {
  // Run this once to handle all dropdowns
  initAllCustomSelects();
});

/**
 * // Highlight an event card and scroll it into view
 * // @param {number|string} eventId - The WordPress Post ID
 */
function highlightEventCard(eventId) {
  // Select by data-event-id
  const card = document.querySelector(
    `.event-card[data-event-id="${eventId}"]`
  );

  if (!card) {
    console.warn(`Event card with ID ${eventId} not found.`);
    return;
  }

  card.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });

  card.classList.add('is-highlighted');

  // Focus for ADA compliance
  card.setAttribute('tabindex', '-1');
  card.focus({ preventScroll: true });

  setTimeout(() => {
    card.classList.remove('is-highlighted');
  }, 2000);
}

// Initialize the map on the single event page
function initSingleEventMap() {
  const mapElement = document.getElementById('single-event-map');

  // Fail gracefully if essential elements or the API are missing
  if (!mapElement || typeof google === 'undefined') {
    return;
  }

  // Parse coordinates from data attributes
  const lat = parseFloat(mapElement.getAttribute('data-lat'));
  const lng = parseFloat(mapElement.getAttribute('data-lng'));
  const title = mapElement.getAttribute('data-title');
  const type = mapElement.getAttribute('data-type');

  if (isNaN(lat) || isNaN(lng)) {
    console.warn('Invalid coordinates for the single event map.');
    return;
  }

  const position = new google.maps.LatLng(lat, lng);

  // Initialize the map with dark mode styles
  const map = new google.maps.Map(mapElement, {
    zoom: 14,
    center: position,
    disableDefaultUI: true,
    styles: [
      { elementType: 'geometry', stylers: [{ color: '#212121' }] },
      { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
      { elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
      { elementType: 'labels.text.stroke', stylers: [{ color: '#212121' }] },
      {
        featureType: 'administrative',
        elementType: 'geometry',
        stylers: [{ color: '#757575' }],
      },
      {
        featureType: 'administrative.country',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }],
      },
      {
        featureType: 'administrative.land_parcel',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'administrative.locality',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#bdbdbd' }],
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#181818' }],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#616161' }],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#1b1b1b' }],
      },
      {
        featureType: 'road',
        elementType: 'geometry.fill',
        stylers: [{ color: '#2c2c2c' }],
      },
      {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#8a8a8a' }],
      },
      {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [{ color: '#373737' }],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ color: '#3c3c3c' }],
      },
      {
        featureType: 'road.highway.controlled_access',
        elementType: 'geometry',
        stylers: [{ color: '#4e4e4e' }],
      },
      {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#616161' }],
      },
      {
        featureType: 'transit',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#000000' }],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#3d3d3d' }],
      },
    ],
  });

  // Place the custom marker
  const marker = new CSSMarker(position, title, type, null, null);
  marker.setMap(map);

  // Disable pointer events so the pin isn't clickable on the single page
  if (marker.div) {
    marker.div.style.pointerEvents = 'none';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Check for the single event wrapper class before execution
  if (document.querySelector('.events-single-box')) {
    initSingleEventMap();
  }
});

// Handling merch filtering
document.addEventListener('DOMContentLoaded', () => {
  const merchGrid = document.getElementById('merchGrid');
  if (merchGrid) {
    initMerchFilters();
  }
});

function initMerchFilters() {
  const grid = document.getElementById('merchGrid');
  const cards = Array.from(grid.querySelectorAll('.merch-card'));
  const categoryInputs = document.querySelectorAll(
    'input[name="merchCategory"]'
  );
  const sizeInputs = document.querySelectorAll('input[name="merchSize"]');
  const sortSelect = document.getElementById('merchSort');
  const clearBtn = document.getElementById('merchClear');
  const countDisplay = document.getElementById('merchCount');

  cards.forEach((card, index) => {
    card.setAttribute('data-original-index', index);
  });

  setupEventListeners({
    grid,
    cards,
    categoryInputs,
    sizeInputs,
    sortSelect,
    clearBtn,
    countDisplay,
  });
}

function setupEventListeners(elements) {
  const { categoryInputs, sizeInputs, sortSelect, clearBtn } = elements;

  categoryInputs.forEach((input) =>
    input.addEventListener('change', () => runFilters(elements))
  );
  sizeInputs.forEach((input) =>
    input.addEventListener('change', () => runFilters(elements))
  );

  if (sortSelect)
    sortSelect.addEventListener('change', () => sortCards(elements));
  if (clearBtn)
    clearBtn.addEventListener('click', () => clearFilters(elements));

  // Custom Select UI Sync
  const customSortOptions = document.querySelectorAll(
    '#merchSortWrapper .custom-select__option'
  );
  customSortOptions.forEach((option) => {
    option.addEventListener('click', function () {
      if (sortSelect) {
        sortSelect.value = this.getAttribute('data-value');
        sortSelect.dispatchEvent(new Event('change'));
      }
    });
  });
}

function runFilters(elements) {
  const { cards, categoryInputs, sizeInputs } = elements;

  const activeCategories = Array.from(categoryInputs)
    .filter((input) => input.checked)
    .map((input) => input.value);
  const activeSizes = Array.from(sizeInputs)
    .filter((input) => input.checked)
    .map((input) => input.value);

  let visibleCount = 0;

  cards.forEach((card) => {
    // Convert comma-separated string to array to support WooCommerce multi-category structure
    const cardCategories = card.getAttribute('data-category').split(',');
    const cardSizes = card.getAttribute('data-sizes').split(',');

    const matchesCategory =
      activeCategories.length === 0 ||
      activeCategories.some((cat) => cardCategories.includes(cat));
    const matchesSize =
      activeSizes.length === 0 ||
      activeSizes.some((size) => cardSizes.includes(size));

    if (matchesCategory && matchesSize) {
      card.style.display = 'flex';
      visibleCount++;
    } else {
      card.style.display = 'none';
    }
  });

  updateCounter(elements, visibleCount);
}

function sortCards(elements) {
  const { grid, cards, sortSelect } = elements;
  const sortValue = sortSelect.value;

  cards.sort((a, b) => {
    if (sortValue === 'price-asc') {
      return (
        parseFloat(a.getAttribute('data-price')) -
        parseFloat(b.getAttribute('data-price'))
      );
    }
    if (sortValue === 'price-desc') {
      return (
        parseFloat(b.getAttribute('data-price')) -
        parseFloat(a.getAttribute('data-price'))
      );
    }

    return (
      parseInt(a.getAttribute('data-original-index')) -
      parseInt(b.getAttribute('data-original-index'))
    );
  });

  cards.forEach((card) => grid.appendChild(card));
}

function clearFilters(elements) {
  const { categoryInputs, sizeInputs, sortSelect } = elements;

  categoryInputs.forEach((input) => (input.checked = false));
  sizeInputs.forEach((input) => (input.checked = false));

  if (sortSelect) {
    sortSelect.value = 'featured';
    const customSelectTrigger = document.querySelector(
      '#merchSortWrapper .custom-select__trigger span'
    );
    if (customSelectTrigger) customSelectTrigger.textContent = 'Featured';
  }

  sortCards(elements);
  runFilters(elements);
}

function updateCounter(elements, count) {
  const { countDisplay } = elements;
  if (countDisplay) countDisplay.textContent = count;
}

const initMerchUrlFilters = () => {
  const merchGrid = document.getElementById('merchGrid');

  // Fail gracefully if essential elements are missing
  if (!merchGrid) {
    return;
  }

  applyCategoryFromUrl();
};

const applyCategoryFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const categoryParam = urlParams.get('merchCategory');

  if (!categoryParam) {
    return;
  }

  const targetCheckbox = document.querySelector(
    `input[name="merchCategory"][value="${categoryParam}"]`
  );

  if (targetCheckbox) {
    targetCheckbox.checked = true;

    // Return the necessary control functions
    const event = new Event('change', { bubbles: true });
    targetCheckbox.dispatchEvent(event);
  }
};

document.addEventListener('DOMContentLoaded', initMerchUrlFilters);

const initProductGallery = () => {
  const galleryBlock = document.querySelector('.pdp__gallery');

  // Fail gracefully if essential elements are missing
  if (!galleryBlock) {
    return;
  }

  // Scope queries to the specific block for better performance
  const mainImage = galleryBlock.querySelector('#pdpMainImage');
  const thumbnails = galleryBlock.querySelectorAll('.pdp__thumbnail');

  if (!mainImage || thumbnails.length === 0) {
    return;
  }

  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', function () {
      const newSrc = this.getAttribute('data-image');

      if (!newSrc) return;

      // Update the main image source
      mainImage.src = newSrc;

      // Clear the srcset so the browser doesn't override the new src with a cached responsive size
      mainImage.removeAttribute('srcset');

      // Manage active states for the UI
      thumbnails.forEach((btn) => btn.classList.remove('is-active'));
      this.classList.add('is-active');
    });
  });
};

document.addEventListener('DOMContentLoaded', initProductGallery);

const initQtyControls = () => {
  const qtyRow = document.querySelector('.pdp__row--qty');

  // Fail gracefully if essential elements are missing
  if (!qtyRow) {
    return;
  }

  const minusBtn = qtyRow.querySelector('.pdp__qty-btn--minus');
  const plusBtn = qtyRow.querySelector('.pdp__qty-btn--plus');
  const qtyInput = qtyRow.querySelector('.pdp__qty-input');

  if (!minusBtn || !plusBtn || !qtyInput) {
    return;
  }

  minusBtn.addEventListener('click', () => {
    let currentValue = parseInt(qtyInput.value, 10) || 1;
    let min = parseInt(qtyInput.min, 10) || 1;

    if (currentValue > min) {
      qtyInput.value = currentValue - 1;
    }
  });

  plusBtn.addEventListener('click', () => {
    let currentValue = parseInt(qtyInput.value, 10) || 1;
    let max = parseInt(qtyInput.max, 10) || 99;

    if (currentValue < max) {
      qtyInput.value = currentValue + 1;
    }
  });
};

document.addEventListener('DOMContentLoaded', initQtyControls);

const initRelatedCarousel = () => {
  const carouselElement = document.querySelector('.pdp__related-carousel');

  // Grab your custom arrows from the header (adjust selectors if your class names are different)
  const customPrev = document.querySelector(
    '.pdp__related-header .splide__arrow--prev'
  );
  const customNext = document.querySelector(
    '.pdp__related-header .splide__arrow--next'
  );

  // Fail gracefully if essential elements are missing
  if (!carouselElement) {
    return;
  }

  const splide = new Splide(carouselElement, {
    type: 'slide',
    perPage: 3,
    gap: '15px',
    pagination: false,
    arrows: false,
    breakpoints: {
      992: {
        perPage: 2,
      },
      600: {
        perPage: 1,
      },
    },
  });

  if (customPrev && customNext) {
    customPrev.addEventListener('click', () => {
      splide.go('<'); // Go to previous slide
    });

    customNext.addEventListener('click', () => {
      splide.go('>'); // Go to next slide
    });

    splide.on('mounted move updated', () => {
      if (splide.index === 0) {
        customPrev.setAttribute('disabled', 'true');
      } else {
        customPrev.removeAttribute('disabled');
      }

      // Disable 'next' if we hit the end of the track
      if (splide.index >= splide.length - splide.options.perPage) {
        customNext.setAttribute('disabled', 'true');
      } else {
        customNext.removeAttribute('disabled');
      }
    });
  }

  // Mount the carousel after everything is configured
  splide.mount();
};

document.addEventListener('DOMContentLoaded', initRelatedCarousel);

document.addEventListener('DOMContentLoaded', () => {
  const videoGrid = document.getElementById('videoGrid');

  // Fail gracefully if we aren't on the video page
  if (videoGrid) {
    initVideoFilters();
    initVideoUrlFilters();
  }
});

function initVideoFilters() {
  const grid = document.getElementById('videoGrid');
  const cards = Array.from(grid.querySelectorAll('.video-card'));

  const checkboxes = document.querySelectorAll(
    '.chip-group input[type="checkbox"]'
  );
  const clearButtons = document.querySelectorAll('[data-clear-group]');

  // 1. Listen for Checkbox changes
  checkboxes.forEach((input) => {
    input.addEventListener('change', (e) => {
      const groupName = e.target.name;
      updateAllButtonState(groupName);
      runVideoFilters(cards);
    });
  });

  // 2. Listen for "All" button clicks
  clearButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const groupName = btn.getAttribute('data-clear-group');

      // Uncheck all inputs in this specific group
      const groupInputs = document.querySelectorAll(
        `input[name="${groupName}"]`
      );
      groupInputs.forEach((input) => (input.checked = false));

      // Set the "All" button back to active
      btn.classList.add('is-active');

      runVideoFilters(cards);
    });
  });
}

function updateAllButtonState(groupName) {
  const groupInputs = document.querySelectorAll(`input[name="${groupName}"]`);
  const allBtn = document.querySelector(`[data-clear-group="${groupName}"]`);

  // Check if ANY checkbox in this group is currently checked
  const hasActiveChecks = Array.from(groupInputs).some(
    (input) => input.checked
  );

  // If checkboxes are active, remove "All" highlight. Otherwise, add it.
  if (hasActiveChecks) {
    allBtn.classList.remove('is-active');
  } else {
    allBtn.classList.add('is-active');
  }
}

function runVideoFilters(cards) {
  // 1. Gather all currently checked values into arrays
  const activeSkills = Array.from(
    document.querySelectorAll('input[name="skill"]:checked')
  ).map((el) => el.value);
  const activeLevels = Array.from(
    document.querySelectorAll('input[name="level"]:checked')
  ).map((el) => el.value);
  const activeDurations = Array.from(
    document.querySelectorAll('input[name="duration"]:checked')
  ).map((el) => el.value);

  let visibleCount = 0;

  // 2. Loop through cards and evaluate matches
  cards.forEach((card) => {
    const cardSkills = card.getAttribute('data-skill').split(',');
    const cardLevel = card.getAttribute('data-level').split(',');
    const cardDuration = card.getAttribute('data-duration').split(',');

    // If the array is empty (meaning "All" is selected), it's an automatic match.
    // Otherwise, check if the card contains AT LEAST ONE of the selected filters in that group.
    const matchesSkill =
      activeSkills.length === 0 ||
      activeSkills.some((val) => cardSkills.includes(val));
    const matchesLevel =
      activeLevels.length === 0 ||
      activeLevels.some((val) => cardLevel.includes(val));
    const matchesDuration =
      activeDurations.length === 0 ||
      activeDurations.some((val) => cardDuration.includes(val));

    if (matchesSkill && matchesLevel && matchesDuration) {
      card.style.display = '';
      card.classList.add('visible');
      visibleCount++;
    } else {
      card.style.display = 'none';
      card.classList.remove('visible');
    }
  });

  const countDisplay = document.getElementById('videoCount');
  if (countDisplay) {
    countDisplay.textContent = visibleCount;
  }
}

function initVideoUrlFilters() {
  const urlParams = new URLSearchParams(window.location.search);
  const groups = ['skill', 'level', 'duration'];
  let filtersApplied = false;

  groups.forEach((group) => {
    // Allow for comma-separated URL params to pre-check multiple boxes
    // Example: ?skill=handles,shooting
    const urlValue = urlParams.get(group);
    if (urlValue) {
      const values = urlValue.split(',');
      values.forEach((val) => {
        const targetCheckbox = document.querySelector(
          `input[name="${group}"][value="${val}"]`
        );
        if (targetCheckbox) {
          targetCheckbox.checked = true;
          filtersApplied = true;
        }
      });
      // Make sure the "All" button for this group updates correctly
      updateAllButtonState(group);
    }
  });

  // If we loaded filters from the URL, immediately run the filter function
  if (filtersApplied) {
    const grid = document.getElementById('videoGrid');
    const cards = Array.from(grid.querySelectorAll('.video-card'));
    runVideoFilters(cards);
  }
}
